<template>
  <!-- Location permission popup -->
  <generic-modal
    v-if="showFetchLocationModal && isFirstTimeUser"
    :height="menuModalDim.height"
    :width="menuModalDim.width"
    :padding="menuModalDim.padding"
    :paddingTop="menuModalDim.paddingTop"
    :modalClass="menuModalDim.modalClass"
    :overflow="menuModalDim.overflow"
    :zIndex="menuModalDim.zIndex"
    :dependentProps="
      showLocationAccessBlockedModal && showLocationPermissionModal
    "
  >
    <template v-slot:header>
      <img
        class="width100"
        :src="staticImgBaseUrl + '/images/global/fetch-location-map.svg'"
      />
    </template>
    <template v-slot:body>
      <div class="mt-150 flex-column justify-content-center">
        <!-- <img
          :src="staticImgBaseUrl + '/images/global/loc-pin.svg'"
          alt="location-pin"
          class="width10 align-self-center"
        /> -->
        <VueLottiePlayer
          name="confettiAnim"
          class="align-self-center"
          width="80px"
          height="80px"
          loop
          :animationData="require('../assets/fetch-location.json')"
        />
        <div v-if="addressHeader == 'No Location'" class="fs-16 bold">
          {{ FetchLocationKeys.FETCHING_YOUR_LOCATION_TEXT }}
        </div>
        <div v-else class="tc plr16">
          <div v-if="currentOrderType == 'D'" class="fs-14 mb8 color-slaty">
            {{ FetchLocationKeys.DELIVERING_TO_TEXT }}
          </div>
          <div class="bold fs-20 mb8">{{ addressHeader + " " }}</div>
          <div class="fs-14 color-slaty">{{ bottomAddressLine }}</div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <ask-location
        :considerIPLocationToSetStoreInCaseAskLater="true"
        class="ask-loc"
      ></ask-location>
    </template>
  </generic-modal>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import GenericModal from "./GenericModal.vue";
import { keyMapsMutation } from "../helpers/storeKeys";
import { shouldLoginFlowSkip } from "../config/apiEndpoints";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import AskLocation from "./AskLocation.vue";
import { FetchLocationKeys } from "./../helpers/addressConstants";
import { OrderTypesFromCode } from "./../helpers/orderTypesConstants";
export default {
  name: "FetchLocation",
  props: ["moduleProps"],
  components: {
    GenericModal,
    AskLocation,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  data() {
    return {
      menuModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        paddingTop: "0px",
        modalClass: "full-screen-popup fetch-location-modal",
        overflow: "hidden",
        zIndex: "999",
      },
      sessionDependedMethodsProcessed: false,
      staticImgBaseUrl,
      matchAddress: false,
      FetchLocationKeys,
    };
  },
  mounted() {},
  methods: {
    matchSavedAddressWithCurrentLoc(currentLat, currentLng) {
      let userAddressList = LocalStorageFunc.getUserAddresses().length
        ? LocalStorageFunc.getUserAddresses()
        : this.$store.state.User.savedAddresses;
      let addressMatchList = [];
      if (userAddressList.length) {
        addressMatchList = userAddressList?.filter((item) =>
          Utility.checkIfNewLocationMatchesSavedAddress(
            currentLat,
            currentLng,
            item
          )
        );
      }
      return addressMatchList.length ? addressMatchList[0] : false;
    },
    computeAddressHeader() {
      let currentGPSLocation =
        this.$store.state.Location.currentGPSLocationData;
      let selectedUserAddress = this.$store.state.User.selectedSavedAddress;
      if (
        !selectedUserAddress &&
        this.currentOrderType === "D" &&
        LocalStorageFunc.isLoggedIn() &&
        currentGPSLocation?.geometry
      ) {
        this.matchAddress = this.matchSavedAddressWithCurrentLoc(
          currentGPSLocation.geometry.location.lat,
          currentGPSLocation.geometry.location.lng
        );
        if (this.matchAddress) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
            this.matchAddress
          );
          LocalStorageFunc.setLocalStorageValue(
            "selectedAddress",
            this.matchAddress
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_AUTO_SELECT_USER_ADDRESS,
            false
          );
        }
      }
      if (selectedUserAddress && this.currentOrderType === "D") {
        return LocalStorageFunc.getSelectedUserAddress()?.customer_address_name;
      } else if (currentGPSLocation.displayAddress) {
        if (this.matchAddress && this.matchAddress?.customer_address_name) {
          return this.matchAddress?.customer_address_name;
        }
        return currentGPSLocation.displayAddress;
      } else if (
        this.isOnHomePage &&
        (!LocalStorageFunc.getDeliveryTypeStationData() ||
          (LocalStorageFunc.getDeliveryTypeStationData() &&
            !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length))
      ) {
        return (
          LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.footerAddress ||
          LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.homePageAddress
            ?.topAddress ||
          FetchLocationKeys.NO_LOCATION_TEXT
        );
      } else if (
        this.isOnHomePage &&
        this.currentOrderType !== "D" &&
        LocalStorageFunc.getDeliveryTypeStationData() &&
        Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length
      ) {
        return OrderTypesFromCode[this.currentOrderType];
      } else if (
        LocalStorageFunc.getSelectedStore() ||
        this.locationData?.address_alias
      ) {
        return this.locationData?.address_alias;
      } else if (this.$store.state.Location.noDeliveryZoneData.displayText) {
        return this.$store.state.Location.noDeliveryZoneData.displayText;
      } else return FetchLocationKeys.NO_LOCATION_TEXT;
    },
  },
  computed: {
    showFetchLocationModal() {
      return this.$store.state.Location.showFetchLocationModal;
    },
    showLocationAccessBlockedModal() {
      return this.$store.state.Location.showLocationAccessBlockedModal;
    },
    showLocationPermissionModal() {
      return this.$store.state.Location.showLocationPermissionModal;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    isFirstTimeUser() {
      return LocalStorageFunc.getFirstTimeUser();
    },
    addressHeader() {
      let text = this.computeAddressHeader();
      if (text == FetchLocationKeys.NO_LOCATION_TEXT) {
        setTimeout(() => {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_FETCH_LOCATION_MODAL,
            false
          );
        }, 8000);
      }
      return text;
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    bottomAddressLine() {
      if (this.addressHeader !== FetchLocationKeys.NO_LOCATION_TEXT) {
        setTimeout(() => {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_FETCH_LOCATION_MODAL,
            false
          );
        }, 4000);
      }
      let currentGPSLocation =
        this.$store.state.Location.currentGPSLocationData;
      if (
        this.isOnHomePage &&
        (!LocalStorageFunc.getDeliveryTypeStationData() ||
          (LocalStorageFunc.getDeliveryTypeStationData() &&
            !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length))
      ) {
        return (
          LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.displayAddress ||
          FetchLocationKeys.EXACT_LOCATION_REQUIRED_TEXT
        );
      } else if (currentGPSLocation.formattedAddress) {
        if (this.matchAddress && this.matchAddress?.formatted_address) {
          return this.matchAddress?.formatted_address;
        }
        return currentGPSLocation.formattedAddress;
      } else if (this.currentOrderType === "D") {
        return (
          LocalStorageFunc.getSelectedUserAddress()?.formatted_address ||
          this.locationData?.complete_address ||
          this.$store.state.Location?.noDeliveryZoneData?.footerText ||
          FetchLocationKeys.EXACT_LOCATION_REQUIRED_TEXT
        );
      } else {
        if (
          this.isChangeTriggeredFromTakeawayDinein &&
          LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
            ?.structuredFormatting
        ) {
          return LocalStorageFunc.getSelectedChangedLocationForTwyDinein()
            ?.structuredFormatting?.mainText;
        } else {
          return (
            LocalStorageFunc.getSelectedUserAddress()?.formatted_address ||
            this.locationData?.complete_address ||
            LocalStorageFunc.getLastLocationNew()?.[0]?.recent
              ?.displayAddress ||
            this.$store.state.Location?.noDeliveryZoneData?.footerText ||
            FetchLocationKeys.EXACT_LOCATION_REQUIRED_TEXT
          );
        }
      }
    },
  },
};
</script>

<style></style>
